import React from "react";

const embed = `<table border="0" width="100%" cellspacing="0" cellpadding="0" style="border-collapse:collapse;"><tr style=""><td style=""><table border="0" width="280" cellspacing="0" cellpadding="0" style="border-collapse:separate;background-color:#ffffff;border:1px solid #dddfe2;border-radius:3px;font-family:Helvetica, Arial, sans-serif;margin:0px auto;"><tr style="padding-bottom: 8px;"><td style="text-align:center;"><img class="img" src="https://scontent-lht6-1.xx.fbcdn.net/v/t31.0-0/c0.0.568.296a/p526x296/14311336_10154506667509629_2957247047234530431_o.jpg?_nc_cat=108&amp;_nc_ht=scontent-lht6-1.xx&amp;oh=9bb0eaa99b86e1143665025b6bbec8fc&amp;oe=5D3D0772" width="280" height="146" alt="" /></td></tr><tr><td style="font-size:14px;font-weight:bold;padding:8px 8px 0px 8px;text-align:center;">Malvern &amp; Worcester Rounders League group page</td></tr><tr><td style="color:#90949c;font-size:12px;font-weight:normal;text-align:center;">Closed group · 603 members</td></tr><tr><td style="padding:8px 12px 12px 12px;"><table border="0" cellspacing="0" cellpadding="0" style="border-collapse:collapse;width:100%;"><tr><td style="background-color:#4267b2;border-radius:3px;text-align:center;"><a style="color:#3b5998;text-decoration:none;cursor:pointer;width:100%;" href="https://www.facebook.com/plugins/group/join/popup/?group_id=4617377170&amp;source=email_campaign_plugin" target="_blank" rel="noopener"><table border="0" cellspacing="0" cellpadding="3" align="center" style="border-collapse:collapse;"><tr><td style="border-bottom:3px solid #4267b2;border-top:3px solid #4267b2;color:#FFF;font-family:Helvetica, Arial, sans-serif;font-size:12px;font-weight:bold;">Join Group</td></tr></table></a></td></tr></table></td></tr><tr><td style="border-top:1px solid #dddfe2;font-size:12px;padding:8px 12px;">Welcome to the Malvern &amp; Worcester Rounders group page!

MWRL is perfect for anyone looking to get back into rounders, or start playing for the fi...</td></tr></table></td></tr></table>`;

const Home = () => {
  return (
    <div className="home">
      <div className="container">
        <div className="row">
          <div className="col s12 l8">
            <h5>Welcome to the Malvern & Worcester Rounders League website!</h5>
            <p>
              MWRL is perfect for anyone looking to get back into rounders, or
              start playing for the first time.
            </p>

            <p>
              We pride ourselves on providing a competitive, fair and fun
              rounders league. The summer ladies league consists of 4 divisions,
              with 25-30 teams playing in total! There are 10-15 mixed teams
              across the year, and 10-15 indoor ladies teams.
            </p>
            <p>
              On this website you will find our season information, important
              documents, a gallery of photos/videos and contact details for the
              MWRL committee.
            </p>
          </div>
          <div
            className="col s12 l4"
            dangerouslySetInnerHTML={{ __html: embed }}
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
